/**
 * Runs: the Прогони list, the Прогін page and the run controls of the task page. Base locale is
 * Ukrainian; the task-page keys live here (and not in `tasks.ts`) so two blocks never edit one file.
 */
export const runs = {
  'runs.title': 'Прогони',
  'runs.intro': 'Кожен запуск агента: закріплені версії, вартість, виклики інструментів і збережений контекст.',
  'runs.empty': 'Прогонів немає',
  'runs.notFound': 'Прогін не знайдено',
  'runs.shown': 'Показано {shown} з {total} · сторінка {page}',
  'runs.page.prev': 'Назад',
  'runs.page.next': 'Далі',

  'runs.filter.allBusinesses': 'Усі бізнеси',
  'runs.filter.allAgents': 'Усі агенти',
  'runs.filter.period': 'Період',
  'runs.filter.today': 'Сьогодні',
  'runs.filter.week': 'Останні 7 днів',
  'runs.filter.month': 'Цей місяць',
  'runs.filter.all': 'Весь час',
  'runs.chip.all': 'Усі',

  'runs.col.task': 'Задача',
  'runs.col.agent': 'Агент',
  'runs.col.model': 'Модель',
  'runs.col.status': 'Статус',
  'runs.col.cost': 'Вартість',
  'runs.col.duration': 'Тривалість',
  'runs.col.started': 'Почато',
  'runs.col.turns': 'Ходів',

  'runs.status.queued': 'у черзі',
  'runs.status.running': 'виконується',
  'runs.status.waitingApproval': 'очікує затвердження',
  'runs.status.waitingReview': 'очікує рев’ю',
  'runs.status.retrying': 'повтор',
  'runs.status.partiallyCompleted': 'частково завершено',
  'runs.status.completed': 'завершено',
  'runs.status.failed': 'помилка',
  'runs.status.cancelled': 'скасовано',
  'runs.status.expired': 'протерміновано',

  'runs.detail.title': 'Прогін {task} · {agent}',
  'runs.detail.noTask': 'без задачі',
  'runs.detail.error': 'Помилка прогону',
  'runs.action.replay': 'Запустити знову',
  'runs.action.cancel': 'Скасувати',
  'runs.action.cancelConfirm': 'Зупинити цей прогін?',

  'runs.versions.template': 'Шаблон',
  'runs.versions.instance': 'Екземпляр',
  'runs.versions.policy': 'Політика',
  'runs.versions.model': 'Модель',
  'runs.versions.prompt': 'Промпт',
  'runs.versions.attempt': 'Спроба',
  'runs.version.n': 'v{n}',
  'runs.tokens': 'Токени: вхід {input} · вихід {output} · кеш {cached}',
  'runs.cost': 'Вартість',

  'runs.timeline.title': 'Хід прогону',
  'runs.timeline.turn': 'Хід {n} · модель {model}',
  'runs.timeline.tool': 'Виклик інструмента {tool}',
  'runs.timeline.args': 'Аргументи',
  'runs.timeline.result': 'Результат',
  'runs.timeline.denied': 'Заборонено політикою: {reason}',
  'runs.timeline.error': 'Помилка інструмента',
  'runs.timeline.resumed': 'Відновлено після збою: {how}',
  'runs.timeline.empty': 'Ще нічого не записано',

  'runs.context.title': 'Контекст (знімок)',
  'runs.context.system': 'Системний промпт',
  'runs.context.user': 'Повідомлення користувача',
  'runs.context.empty': 'Знімок контексту не збережено',
  'runs.result.title': 'Результат',

  'runs.artifacts.title': 'Артефакти',
  'runs.artifacts.type': 'Тип',
  'runs.artifacts.version': 'Версія',
  'runs.artifacts.status': 'Статус',
  'runs.artifacts.created': 'Коли',
  'runs.artifacts.empty': 'Артефактів немає',
  'runs.artifactStatus.draft': 'чернетка',
  'runs.artifactStatus.reviewed': 'перевірено',
  'runs.artifactStatus.approved': 'затверджено',
  'runs.artifactStatus.superseded': 'замінено',

  'runs.actions.title': 'Зовнішні дії',
  'runs.actions.tool': 'Інструмент',
  'runs.actions.status': 'Статус',
  'runs.actions.idempotency': 'Ідемпотентність',
  'runs.actions.reference': 'Зовнішнє посилання',
  'runs.actions.attempt': 'Спроба',
  'runs.actions.error': 'Помилка',
  'runs.actions.empty': 'Зовнішніх дій не було',
  'runs.actionStatus.planned': 'заплановано',
  'runs.actionStatus.executing': 'виконується',
  'runs.actionStatus.done': 'виконано',
  'runs.actionStatus.failed': 'помилка',
  'runs.actionStatus.rolledBack': 'відкочено',

  'runs.approvals.title': 'Затвердження',
  'runs.approvals.when': 'Коли',
  'runs.approvals.kind': 'Вид',
  'runs.approvals.decision': 'Рішення',
  'runs.approvals.approver': 'Хто',
  'runs.approvals.channel': 'Канал',
  'runs.approvals.expires': 'Строк дії',
  'runs.approvals.empty': 'Затверджень не потрібно',
  'runs.kind.step': 'Результат прогону',
  'runs.kind.externalAction': 'Зовнішня дія',
  'runs.kind.plan': 'План',
  'runs.kind.newAgent': 'Новий агент',
  'runs.kind.knowledge': 'Знання',
  'runs.decision.pending': 'очікує рішення',
  'runs.decision.approved': 'погоджено',
  'runs.decision.rework': 'на доопрацювання',
  'runs.decision.rejected': 'відхилено',
  'runs.channel.panel': 'панель',
  'runs.channel.telegram': 'Telegram',

  'runs.error.notFound': 'Прогін не знайдено',
  'runs.error.invalidStatus': 'Цей прогін уже не виконується',
  'runs.error.budgetHardLimit': 'Досягнуто жорсткий ліміт бюджету — новий прогін не запускається',
  'runs.error.instanceNotActive': 'Агент не активний',
  'runs.error.taskNotFound': 'Задачу не знайдено',

  // ---- task page ----
  'task.run.assign': 'Доручити агенту',
  'task.run.start': 'Запустити',
  'task.run.noAgents': 'Активних агентів для цього бізнесу ще немає',
  'task.badge.agent': 'агент',
  'task.runs.title': 'Прогони',
  'task.runs.open': 'Прогін',
  'task.history.runStarted': 'Прогін запущено ({agent})',
  'task.history.runCompleted': 'Прогін завершено ({cost})',
  'task.history.runFailed': 'Прогін завершився помилкою',
  'task.history.runCancelled': 'Прогін скасовано',
} as const;
